export const testimonials = [
  {
    quote: "Victrie didn't just build our platform — they reimagined it. The AI credit-scoring engine they delivered cut our loan approval time from days to seconds.",
    name: "Amina Wanjiru",
    role: "CEO, PesaFlow"
  },
  {
    quote: "The most disciplined engineering team we've worked with. Weekly demos, zero surprises, and a product that scaled to a million users without a hiccup.",
    name: "Daniel Otieno",
    role: "CTO, Safiri Logistics"
  },
  {
    quote: "Their design work is world-class. Our app went from a 3.2 to a 4.9 rating within three months of the redesign Victrie delivered.",
    name: "Sarah Mitchell",
    role: "Head of Product, AfyaLink"
  },
  {
    quote: "From cloud migration to a full DevOps overhaul, Victrie made our infrastructure boringly reliable. Our costs dropped 40% and downtime disappeared.",
    name: "Kwame Mensah",
    role: "VP Engineering, Nexus Manufacturing"
  },
];

export const faqs = [
  {
    q: "What does Victrie do?",
    a: "Victrie is a full-service software development company based in Nairobi, Kenya. We design, build and scale next-generation digital products: custom software, AI and machine learning solutions, web and mobile applications, cloud infrastructure and data platforms for startups, enterprises and governments worldwide.",
  },
  {
    q: "How much does custom software development cost?",
    a: "Every project is unique, so we scope carefully before quoting. Small MVPs typically start from a few thousand dollars, while enterprise platforms are larger multi-phase engagements. We offer fixed-price, time-and-materials and dedicated-team models so you can choose what fits your budget and risk appetite. Contact us for a free estimate.",
  },
  {
    q: "How long does it take to build an app or software product?",
    a: "A focused MVP usually ships in 8–12 weeks. Larger platforms are delivered in phased releases every 4–6 weeks so you get value early and continuously. During discovery we give you a realistic timeline with milestones.",
  },
  {
    q: "Do you work with clients outside Kenya?",
    a: "Yes. While we are proudly headquartered in Nairobi, we serve clients across Africa, Europe, North America and the Middle East. Our teams work in overlapping time zones and communicate through Slack, video calls and shared project boards.",
  },
  {
    q: "Can you integrate M-Pesa and other payment systems?",
    a: "Absolutely. We have deep experience with M-Pesa (Daraja API), Airtel Money, Stripe, Flutterwave, Paystack, PayPal and card processors. We build PCI-aware payment flows and reconciliation systems.",
  },
  {
    q: "Which technologies do you use?",
    a: "We choose the best tool for the job. Common stacks include React, Next.js, TypeScript, Node.js, Python, Go, React Native, Flutter, PostgreSQL, MongoDB, AWS, Azure, Google Cloud, Kubernetes, TensorFlow, PyTorch and modern LLM frameworks.",
  },
  {
    q: "Do you provide support after launch?",
    a: "Yes. We offer flexible maintenance and support plans including 24/7 monitoring, security patches, performance optimization and feature development so your product keeps improving long after launch.",
  },
  {
    q: "Who owns the code and intellectual property?",
    a: "You do. On completion of the project and payment, all source code, designs and intellectual property are transferred to you in full.",
  },
];

export const values = [
  { icon: "Rocket", title: "Future-first", text: "We build for where technology is going, not where it has been. Every solution is designed to stay relevant for years." },
  { icon: "Users", title: "Radically human", text: "Technology exists to serve people. We obsess over the humans on both sides of every screen." },
  { icon: "Bolt", title: "Relentless quality", text: "Clean code, rigorous testing and thoughtful design are non-negotiable. Good enough is never good enough." },
  { icon: "Shield", title: "Trust by default", text: "Transparent pricing, honest timelines and secure-by-design engineering. We earn trust every single sprint." },
  { icon: "Layers", title: "Think in systems", text: "We see the whole picture: business model, users, data and infrastructure, and design solutions that fit together." },
  { icon: "Spark", title: "Endless curiosity", text: "We experiment, learn and share. Our team spends every Friday exploring emerging technology." },
];
